/**
 * Simplifies combining class names.
 *
 * @deprecated please use `classnames` or `tw` from `@panwds/tailwindcss`
 *
 * @example
 * classNames(
 *   'here are some default class names',
 *   onlyWhenThisIsTruthy && 'yep it is truthy',
 *   maybeUseTernaries ? 'yep' : 'nope
 * );
 * @param classes
 */
function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
}

export { classNames };
//# sourceMappingURL=classNames.esm.js.map
